/**
 * @generated SignedSource<<74942ae9c967bca439387f1dfa72ae27>>
 * @relayHash 6c5167a1bbf05b42c4afa172d56949c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6dbea747f9858c339454be3227595ec2646efba5b1e5275dd494e21c3c8a3c3e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

import isBusinessStatusMappingEnabled_provider from '@atlassian/jira-relay-provider/src/allow-status-mapping-on-business-board.relayprovider';
import isUsingNewCreate_provider from '@atlassian/jira-relay-provider/src/mbw-67-board-issue-create.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6dbea747f9858c339454be3227595ec2646efba5b1e5275dd494e21c3c8a3c3e",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": isBusinessStatusMappingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw67boardissuecreaterelayprovider": isUsingNewCreate_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};

export default node;
